import { render, staticRenderFns } from "./FileComparison.vue?vue&type=template&id=9d6fa58e&"
import script from "./FileComparison.vue?vue&type=script&lang=js&"
export * from "./FileComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports